import React, { useCallback } from 'react';

import { getPpeStocksList } from 'api/hs/ppe/ppe-stocks';
import { HSTableProps } from 'Common/Table/HSTable/hs-table.props';
import HSTableAndPaginationAndTableContextProvider from 'Common/Table/HSTable/HSTableAndPaginationAndTableContextProvider';

import EditDialog from '../EditDialog';
import { COLUMNS } from './columns';
import ListTable from './ListTableData';
import Toolbar from './Toolbar';

export default function PPEStocksList() {
  const fetchPpeStocksList = useCallback<HSTableProps<any>['fetcher']>((page, size, sorting, extra) => {
    return getPpeStocksList(
      page,
      size,
      sorting === false ? null : `${sorting.id as string}-${sorting.direction.toUpperCase()}`,
      extra.filters ?? {}
    );
  }, []);

  return (
    <>
      <HSTableAndPaginationAndTableContextProvider fetcher={fetchPpeStocksList} columns={COLUMNS}>
        <Toolbar />
        <ListTable />
        <EditDialog />
      </HSTableAndPaginationAndTableContextProvider>
    </>
  );
}
